import PropTypes from 'prop-types'

import React from 'react'
import {Http, i18n, config} from 'common'
import {browserHistory, HashRouter as Router, Route, Switch} from 'react-router-dom'

import {NavBar, SideBar, Loader} from './components'
import {ConfigProvider, withConfig} from './providers/ConfigProvider'
import {NotifyProvider} from './providers/NotifyProvider'

import Clients from './pages/Clients';
import Scopes from './pages/Scopes';
import Approved from './pages/Approved';
import Tokens from './pages/Tokens';
import Support from './pages/Support';

import ClientEdit from './forms/ClientEdit';
import ScopeEdit from './forms/ScopeEdit';
import WhitelistEdit from './forms/WhitelistEdit';


export default class App extends React.Component {
  static contextTypes = {
    oauth: PropTypes.object.isRequired
  };

  state = {
    systemConfig: null,
    systemScopes: null,
    whitelists: null,
    errorMessage: null,
    csrfToken: null
  };

  componentDidMount() {
    Http.GET('api/environment', (data) => {
      const {user: {authorities}} = data

      if (authorities.includes('ROLE_ADMIN')) {
        Http.setErrorHandler(this.onHttpError);
        this.onReload();
      } else {
        window.location = `${config.EXCEPTION_URL}?status=401&error=AccessDenied`
      }
    });
  }

  onReload = () => {
    Http.GET('csrf', (data) => this.setState({csrfToken: data.token}));
    Http.GET('api/scopes', (data) => this.setState({systemScopes: data}));
    Http.GET('api/whitelist', (data) => this.setState({whitelists: data}));
    Http.GET('.well-known/openid-configuration', (data) => this.setState({systemConfig: data}));
  }

  onHttpError = (code, body) => {
    if (code === 401) {
      this.context.oauth.reset()
      return;
    }

    const { notifyProvider } = this.refs;
    notifyProvider.message(body.message||body.error_description, 'error');
  }

  render() {
    const { systemConfig, systemScopes, whitelists } = this.state;
    const { errorMessage, csrfToken } = this.state;

    return (
      <ConfigProvider scopes={systemScopes} features={systemConfig} whitelists={whitelists}
                      onChange={this.onReload}>
        <Router basename="/" history={browserHistory}>
          <div>
            <NavBar buttons={[['Admin', 'admin.html'], ['Login', 'login.html']]} csrfToken={csrfToken}>
              <Switch>
                <Route exact path="/" render={() => i18n('manage-clients.title')} />
                <Route exact path="/scopes" render={() => i18n('manage-scopes.title')} />
                <Route exact path="/support" render={() => i18n('support-users.title')} />

                <Route path="/clients/:relationId/whitelists/new" render={() => i18n('whitelist-form.title.new')} />
                <Route exact path="/clients/new" render={() => i18n('client-form.title.new')} />
                <Route exact path="/scopes/new" render={() => i18n('scope-form.title.new')} />

                <Route path="/clients/:relationId/whitelists/:id" render={() => i18n('whitelist-form.title.edit')} />
                <Route path="/clients/:id" render={() => i18n('client-form.title.edit')} />
                <Route path="/scopes/:id" render={() => i18n('scope-form.title.edit')} />
              </Switch>
            </NavBar>

            <div className="layout">
              <SideBar />

              <main className="content">
                <NotifyProvider ref="notifyProvider">
                  <Loader trigger={systemConfig && systemScopes && whitelists}>
                    <Switch>
                      <Route exact path="/" component={Clients} name="Manage Clients" />
                      <Route exact path="/scopes" component={Scopes} name="Manage Scopes" />
                      <Route exact path="/support" component={Support} name="Support Users" />

                      <Route path="/clients/:relationId/whitelists/new" component={WhitelistEdit} name="New Whitelist" />
                      <Route exact path="/clients/new" component={ClientEdit} name="New Client" />
                      <Route exact path="/scopes/new" component={ScopeEdit} name="New Scope" />

                      <Route path="/clients/:relationId/whitelists/:id" component={WhitelistEdit} name="Edit Whitelist" />
                      <Route path="/clients/:id" component={ClientEdit} name="Edit Client" />
                      <Route path="/scopes/:id" component={ScopeEdit} name="Edit Scope" />
                    </Switch>
                  </Loader>
                </NotifyProvider>
              </main>

            </div>
          </div>
        </Router>
      </ConfigProvider>
    );
  }
};
